import { CSSProperties, useMemo } from 'react';
import { Border, BorderStyle } from 'componentregistry';
import { useTheme } from 'theme/Theme';
import { Theme } from '@mui/material';

export function getBorder(
  value: BorderStyle,
  theme: Theme,
): string | undefined {
  if (value.width === 0) {
    return undefined;
  }
  let color = value.borderColor ?? theme.palette.divider;
  if (color === 'rgba(0, 0, 0, 0.12)') {
    color = theme.palette.divider;
  }
  const colorString =
    typeof color === 'object'
      ? `rgba(${color.r},${color.g},${color.b},${color.a})`
      : color;
  return `${value.width}px ${value.style ?? 'solid'} ${colorString}`;
}

export default function useBorder(border?: Border): CSSProperties {
  const theme = useTheme();
  return useMemo(() => {
    const style: CSSProperties = {};
    if (border?.all) {
      style.border = getBorder(border.all, theme);
    } else {
      if (border?.top) {
        style.borderTop = getBorder(border.top, theme);
      }
      if (border?.right) {
        style.borderRight = getBorder(border.right, theme);
      }
      if (border?.bottom) {
        style.borderBottom = getBorder(border.bottom, theme);
      }
      if (border?.left) {
        style.borderLeft = getBorder(border.left, theme);
      }
    }
    return style;
  }, [border, theme]);
}
